import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { Row, Space } from 'antd';
import Button from 'components/Button';
import DateInterval from 'components/InputDateInterval';
import InputSelect from 'components/InputSelect';
import InputSelectMultiple from 'components/InputSelectMultiple';
import { fetchNotificationApp } from 'store/fetchActions/fetchApp';
import { fetchDownloadRelatorioDetalhado } from 'store/fetchActions/fetchRelatorios';
import {
  FORMULARIOS,
  ALERTA,
  MSG_INPUT_MAX_SERVICO,
  MSG_INPUT_MAX_ATENDENTES,
  ENUM_TIPO_RELATORIO,
} from 'utils/consts';
import { todosTipoPeriodo } from './Filtro';
import { validarButtonPesquisar } from 'utils/validate/relatorio';
import { formatterFiltroRelatoriosFrontToBack } from 'utils/formatter/filtro';
import { changeInputFilter } from 'utils/formUtils';
import { ENUM_TIPO_PERFIL } from 'utils/permissao';
import * as S from './styles';
import * as Style from 'components/Style';
import { fetchDetalharSetorPorId } from 'store/fetchActions/fetchSetores';
import { montaNomeAtendente } from 'utils/funcaoPadrao';

export default function FiltroRelatorios({
  salvarFiltro,
  filtro,
  relatorioNome = 'Relatorio_',
  funcPesquisar,
  tipoRelatorio,
  isPerformanceGeral = false,
  cleanDadosGrafico,
  dadosGrafico,
  todosAssuntos,
  todosServicos,
  todosAtendentes,
  todosSetores,
  isPesquisaAtendenteSetorial = false,
  showInputSetor = false,
  showInputAssunto = false,
  showInputAtendente = false,
}) {
  const dispatch = useDispatch();
  const user = useSelector(state => state.sefaz.userProfile);

  const [isClear, setIsClear] = useState(false);
  const [disabledBtnPesquisar, setDisabledBtnPesquisar] = useState(true);
  const [disabledExportar, setDisabledExportar] = useState(true);
  const [exibirServicos, setExibirServicos] = useState(false);
  const [atendentesFiltradoExibir, setAtendentesFiltradoExibir] = useState(todosAtendentes);

  const { watch, control, handleSubmit, setValue, getValues, reset } = useForm({
    defaultValues: {
      tipoPeriodo: '',
      dataPesquisa: '',
      setor: '',
      assunto: '',
      servico: '',
      atendente: '',
    },
  });

  React.useEffect(() => {
    if (dadosGrafico?.length === 0) {
      setDisabledExportar(true);
    }
  }, [dadosGrafico]);

  const handleChangeInput = e => {
    const { value, name } = e.target;
    changeInputFilter(e, setValue);

    if (name === 'assunto') {
      value === FORMULARIOS?.SERVICOS.id ? setExibirServicos(true) : setExibirServicos(false);
      if (e !== FORMULARIOS.SERVICOS.id) setValue('servico', '');
    }
    setDisabledBtnPesquisar(
      !!validarButtonPesquisar(
        tipoRelatorio,
        isPerformanceGeral,
        user?.profile === ENUM_TIPO_PERFIL.SUPERVISOR_SETORIAL,
        getValues()
      )
    );
  };

  const onSubmit = data => {
    const mensagemIsValid = validarButtonPesquisar(
      tipoRelatorio,
      isPerformanceGeral,
      user?.profile === ENUM_TIPO_PERFIL.SUPERVISOR_SETORIAL,
      getValues()
    );
    if (mensagemIsValid) {
      fetchNotificationApp('', mensagemIsValid, ALERTA.AVISO);
    } else {
      const dadosFormatados = formatterFiltroRelatoriosFrontToBack(
        data,
        tipoRelatorio,
        todosTipoPeriodo,
        isPesquisaAtendenteSetorial
      );
      salvarFiltro(dadosFormatados);
      funcPesquisar(dadosFormatados, 1, 10);
      setDisabledExportar(false);
    }
  };

  const exportarRelatorio = () => {
    dispatch(fetchDownloadRelatorioDetalhado({ ...filtro }, relatorioNome));
  };

  const limparFiltro = () => {
    setIsClear(true);
    setDisabledBtnPesquisar(true);
    setDisabledExportar(true);
    salvarFiltro({});
    cleanDadosGrafico();
    setExibirServicos(false);
    reset();
  };

  const changeServico = arrayServicosId => {
    if (arrayServicosId?.length > 6) {
      fetchNotificationApp('', MSG_INPUT_MAX_SERVICO, ALERTA.AVISO);
      setDisabledBtnPesquisar(true);
    } else {
      handleChangeInput({
        target: {
          name: 'servico',
          value: arrayServicosId,
        },
      });
    }
  };

  const changeAtendente = arrayAtendenteId => {
    if (arrayAtendenteId?.length > 6) {
      fetchNotificationApp('', MSG_INPUT_MAX_ATENDENTES, ALERTA.AVISO);
      setDisabledBtnPesquisar(true);
    } else {
      handleChangeInput({
        target: {
          name: 'atendente',
          value: arrayAtendenteId,
        },
      });
    }
  };

  const changeTipoPeriodo = valor => {
    setValue('tipoPeriodo', '');
    setIsClear(true);
    handleChangeInput({
      target: {
        name: 'tipoPeriodo',
        value: valor,
      },
    });
  };

  const changeSetor = valor => {
    if (tipoRelatorio === ENUM_TIPO_RELATORIO.ATENDIMENTOS && user?.profile === ENUM_TIPO_PERFIL.SUPERVISOR_SETORIAL) {
      dispatch(fetchDetalharSetorPorId(valor)).then(res => {
        setAtendentesFiltradoExibir(
          res?.atendentes?.map(atendente => {
            return {
              value: atendente?.id,
              label: montaNomeAtendente(atendente?.nome),
            };
          })
        );
        handleChangeInput({
          target: {
            name: 'atendente',
            value: '',
          },
        });
      });
    }
    handleChangeInput({
      target: {
        name: 'setor',
        value: valor,
      },
    });
  };

  return (
    <form>
      <Style.GlobalCard>
        <Row>
          <S.ContainerInput width="10%">
            <InputSelect
              label="Tipo de Período"
              name="tipoPeriodo"
              placeholder="Período"
              control={control}
              options={todosTipoPeriodo}
              viewChange={e => changeTipoPeriodo(e)}
            />
          </S.ContainerInput>
          <DateInterval
            tipoPeriodo={watch('tipoPeriodo')}
            label={`Data da Pesquisa (${todosTipoPeriodo?.find(x => x.value === watch('tipoPeriodo'))?.label})`}
            name="dataPesquisa"
            control={control}
            onChange={handleChangeInput}
            isClear={isClear}
            openChange={() => setIsClear(false)}
            required
          />
          {showInputSetor && (
            <S.ContainerInput>
              <InputSelect
                label="Nome do Setor"
                name="setor"
                placeholder={'Nome do Setor'}
                control={control}
                options={todosSetores}
                viewChange={changeSetor}
              />
            </S.ContainerInput>
          )}
          {showInputAssunto && (
            <S.ContainerInput width="20%">
              <InputSelect
                label="Assunto"
                name="assunto"
                placeholder={'Assunto'}
                control={control}
                options={todosAssuntos}
                viewChange={e => handleChangeInput({ target: { name: 'assunto', value: e } })}
              />
            </S.ContainerInput>
          )}
          {exibirServicos && (
            <S.ContainerInput width="23%">
              <InputSelectMultiple
                label="Serviço"
                name="servico"
                control={control}
                placeholder={'Serviços'}
                viewChange={changeServico}
                viewDeselect={changeServico}
                options={todosServicos}
                initialValue={watch('servico')}
              />
              <div style={{ width: '100%', textAlign: 'left' }}>* É permitido a seleção de no máximo 6 serviços</div>
            </S.ContainerInput>
          )}

          {showInputAtendente && (
            <S.ContainerInput>
              <InputSelectMultiple
                label={`Atendente ${isPesquisaAtendenteSetorial ? 'Setorial' : ''}`}
                name="atendente"
                placeholder={'Atendente'}
                control={control}
                viewChange={changeAtendente}
                viewDeselect={changeAtendente}
                options={atendentesFiltradoExibir?.length > 0 ? atendentesFiltradoExibir : todosAtendentes}
                initialValue={watch('atendente')}
              />
            </S.ContainerInput>
          )}
          <S.ContainButton>
            <Space>
              <Button text={'Pesquisar'} clickAction={handleSubmit(onSubmit)} disabled={disabledBtnPesquisar} />
              <Button text={'Limpar Filtro'} clickAction={() => limparFiltro()} disabled={disabledBtnPesquisar} />
              <Button text={'Exportar Relatório'} clickAction={() => exportarRelatorio()} disabled={disabledExportar} />
            </Space>
          </S.ContainButton>
        </Row>
      </Style.GlobalCard>
    </form>
  );
}
